export const isNFL = (channelInfo) => {
    return channelInfo?.isOptinRequired ?? false;
}